/*************************************
 *
 *  Esports Top Ranked Teams Data
 *
 ************************************/
export const esportsTopRankedTeamsData = [
  {
    teamGroupImage: require("../assets/esports-teams-images/team-roster-images/team-soul-roster.png"),
    teamName: "Soul Esports",
    teamTitleWon: "BMPS S2 Champions",
    teamLogo: require("../assets/esports-teams-images/team-logos/team-soul-logo.png"),
    playerOneName: "Omega",
    playerTwoName: "Akshat",
    playerThreeName: "Goblin",
    playerFourName: "Hector",
    playerOneRole: "IGL",
    playerTwoRole: "Assaulter",
    playerThreeRole: "Entry Fragger",
    playerFourRole: "Supporter",
  },
  {
    teamGroupImage: require("../assets/esports-teams-images/team-roster-images/team-xo-roster.jpg"),
    teamName: "Team XO",
    teamTitleWon: "BGIS S2 Champions",
    teamLogo: require("../assets/esports-teams-images/team-logos/team-xo-logo.png"),
    playerOneName: "Sensei",
    playerTwoName: "Immortal",
    playerThreeName: "Punkk",
    playerFourName: "Fierce",
    playerOneRole: "IGL",
    playerTwoRole: "Scout",
    playerThreeRole: "Flanker",
    playerFourRole: "Assaulter",
  },
  {
    teamGroupImage: require("../assets/esports-teams-images/team-roster-images/team-7sea-roster.jpg"),
    teamName: "7Sea Esports",
    teamTitleWon: "BMSD Champions",
    teamLogo: require("../assets/esports-teams-images/team-logos/team-7sea-logo.png"),
    playerOneName: "Sarang",
    playerTwoName: "SprayGod",
    playerThreeName: "Prince",
    playerFourName: "Aladin",
    playerOneRole: "IGL",
    playerTwoRole: "Supporter",
    playerThreeRole: "Flanker",
    playerFourRole: "Assaulter",
  },
  {
    teamGroupImage: require("../assets/esports-teams-images/team-roster-images/team-enigma-roster.webp"),
    teamName: "Enigma Gaming",
    teamTitleWon: "BMPS S1 Champions",
    teamLogo: require("../assets/esports-teams-images/team-logos/team-enigma-logo.png"),
    playerOneName: "Avii",
    playerTwoName: "Eggy",
    playerThreeName: "Rexx",
    playerFourName: "Evoo",
    playerOneRole: "IGL",
    playerTwoRole: "Entry Fragger",
    playerThreeRole: "Flanker",
    playerFourRole: "Assaulter",
  },
  {
    teamGroupImage: require("../assets/esports-teams-images/team-roster-images/team-xspark-roster.jpg"),
    teamName: "Team XSpark",
    teamTitleWon: "BMOC Champions",
    teamLogo: require("../assets/esports-teams-images/team-logos/team-xspark-logo.png"),
    playerOneName: "Mavi",
    playerTwoName: "Ultron",
    playerThreeName: "Juicyy",
    playerFourName: "ScoutOp",
    playerOneRole: "IGL",
    playerTwoRole: "Supporter",
    playerThreeRole: "Spoiler",
    playerFourRole: "Assaulter",
  },
  {
    teamGroupImage: require("../assets/esports-teams-images/team-roster-images/team-chemin-roster.jpg"),
    teamName: "Chemin Esports",
    teamTitleWon: "BGIS S1 Champions",
    teamLogo: require("../assets/esports-teams-images/team-logos/team-chemin-logo.png"),
    playerOneName: "Destro",
    playerTwoName: "Delta",
    playerThreeName: "Robin",
    playerFourName: "Justin",
    playerOneRole: "IGL",
    playerTwoRole: "Assaulter",
    playerThreeRole: "Flanker",
    playerFourRole: "Spoiler",
  },
];
